import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { FormErrors } from '../../inc/error-form';
import { GetText, ReplaceInsText, ReplaceText } from '../../config/helper';
import { FaCircleCheck } from 'react-icons/fa6';

const authKey = global.config.kindcode.training[17]+global.config.authBearerKey;

export default class ModalStoriesForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      member_id: localStorage.getItem('doc_id'),
      member_email: "",
      stories_id: "",
      stories_name: "",
      stories_email: "",
      stories_position: "",
      stories_company: "",
      stories_type: "",
      stories_message: "",
      formErrors: { stories_name: '', stories_email: '', stories_position: '', stories_company: '', stories_message: ''},
      storiesnameValid: false,
      storiesemailValid: false,
      storiespositionValid: false,
      storiescompanyValid: false,
      storiesmessageValid: false,
      formValid: false,
      input_disabled: true
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleUserInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({[name]: value},
        () => { this.validateField(name, value)});
  }

  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let storiesnameValid = this.state.storiesnameValid;
    let storiesemailValid = this.state.storiesemailValid;
    let storiespositionValid = this.state.storiespositionValid;
    let storiescompanyValid = this.state.storiescompanyValid;
    let storiesmessageValid = this.state.storiesmessageValid;
    
    switch(fieldName) {
        case 'stories_name': 
            storiesnameValid = value.trim().length > 0;
            fieldValidationErrors.stories_name = storiesnameValid ? '' : 'name need to be filled';
            break;
        case 'stories_email': 
            storiesemailValid = value.trim().length > 0;
            fieldValidationErrors.stories_email = storiesemailValid ? '' : 'email need to be filled';
            break;
        case 'stories_position': 
            storiespositionValid = value.trim().length > 0;
            fieldValidationErrors.stories_position = storiespositionValid ? '' : 'position / job title need to be filled';
            break;
        case 'stories_company': 
            storiescompanyValid = value.trim().length > 0;
            fieldValidationErrors.stories_company = storiescompanyValid ? '' : 'company need to be filled';
            break;
        case 'stories_message': 
            storiesmessageValid = value.trim().length > 0;
            fieldValidationErrors.stories_message = storiesmessageValid ? '' : 'message need to be filled';
            break;
        default:
            break;
    }
    
    this.setState({formErrors: fieldValidationErrors,
                    storiesnameValid: storiesnameValid,
                    storiesemailValid: storiesemailValid,
                    storiespositionValid: storiespositionValid,
                    storiescompanyValid: storiescompanyValid,
                    storiesmessageValid: storiesmessageValid,
                }, this.validateForm);
  }

  validateForm() {
    this.setState({formValid: this.state.storiesnameValid && this.state.storiesemailValid && this.state.storiespositionValid && this.state.storiescompanyValid && this.state.storiesmessageValid });
  }

  errorClass(error) {
    return(error.length === 0 ? '' : 'has-error');
  }

  handleSubmit(e) {
    e.preventDefault();
    if(this.state.stories_name !== '' && this.state.stories_email !== '' && this.state.stories_message !== '' ) {
        document.getElementById('loading-area').style.display = 'block'; 
        var urlFetch, datatext;
        var storiesName,storiesEmail,storiesPosition,storiesCompany,storiesMessage;
        if(this.textInputStoriesName.value === '') { storiesName = this.state.stories_name; } else { storiesName = this.textInputStoriesName.value; }
        if(this.textInputStoriesEmail.value === '') { storiesEmail = this.state.stories_email; } else { storiesEmail = this.textInputStoriesEmail.value; }
        if(this.textInputStoriesPosition.value === '') { storiesPosition = this.state.stories_position; } else { storiesPosition = this.textInputStoriesPosition.value; }
        if(this.textInputStoriesCompany.value === '') { storiesCompany = this.state.stories_company; } else { storiesCompany = this.textInputStoriesCompany.value; }
        
        if(this.textInputStoriesMessage.value === '') { storiesMessage = this.state.stories_message; } else { storiesMessage = this.textInputStoriesMessage.value; }
        storiesMessage = ReplaceInsText(storiesMessage);
            
        var datatext='{';
        datatext += '"stories_name":"'+storiesName+'","stories_email":"'+storiesEmail+'","stories_position":"'+storiesPosition+'","stories_company":"'+storiesCompany+'","stories_message":"'+storiesMessage+'","stories_type":"'+this.state.stories_type+'","stories_status":"'+global.config.storiesinStatus[0]+'"';
        datatext +=',"form_id":"form-add"';
        urlFetch = global.config.urlLink+"/storiesinadd";

        datatext += '}'
        var data = JSON.parse(datatext);
        fetch(urlFetch, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': authKey,
            }, body : JSON.stringify(data)
        }).then(res => {
            if(res.status === 200) 
                return res.json() 
        }).then( resJson => {
            if(resJson.status === '200') {
                var docId = resJson.values;
                this.setState({ 
                    stories_id: docId,
                  });
            } else {
                console.log('Something happened wrong');
            }

            document.getElementById('loading-area').style.display = 'none'; 
        }).catch(err => { 
            document.getElementById('loading-area').style.display = 'none'; 
        });
    
    } else {
        var arrfieldName = ['stories_name','stories_email','stories_message'];
        var arrvalue = [this.textInputStoriesName.value,this.textInputStoriesEmail.value,this.textInputStoriesMessage.value];
        for(var ck in arrfieldName) {
            this.validateField(arrfieldName[ck], arrvalue[ck]);
        }
    }
  }

  componentDidMount() {
    this.setState({
        stories_id: "",
        stories_name: "",
        stories_email: "",
        stories_position: "",
        stories_company: "",
        stories_type: global.config.specialCategory[0].value,
        stories_message: "",
        formErrors: { stories_name: '', stories_email: '', stories_position: '', stories_company: '', stories_message: ''},
        input_disabled: false
    }) 
  }

  render() {
    return (
        <div className="container mb-4">
          <div id="success-stories-form">
             {
                this.state.stories_id !== "" ? (
                    <div className="p-4 mb-5  w-100 d-flex justify-content-center"> 
                        <div className="row">
                          <div className="col-lg-2 d-flex align-items-center justify-content-center">
                            <FaCircleCheck color="green" fontSize="80px"/>
                          </div>
                          <div className="col-lg-10">
                            <div  className="mt-1 ms-2 fs-3">{GetText()? "Berhasil dikirim" : "Success submitted"}</div>
                            <div  className="mt-2 ms-2 fs-6">{GetText()? "Terima kasih atas kesediaan anda untuk berbagi pengalaman dan cerita Anda." : "Thank you for sharing your experiences and/or stories."} </div>
                          </div>
                        </div>
                  </div>  
                ) : (
                <>
                <div className="mt-1">
                    <p className='fs-6'>{GetText() ? "Ceritakan pengalaman menarik Anda selama menggunakan Google Gemini Atau saat mengikuti pelatihan Anda disini." : "Share your interesting experiences while using Google Gemini or while taking your training here."}</p>
                </div>
                
                <div className="mt-4">
                    <div >
                    <form onSubmit={this.handleSubmit}>
                        <div className="mt-3">
                            <label htmlFor="stories_name">{GetText()? "Nama" : "Name"}</label>
                            <div className="mt-1">
                                <input type="text" className="form-control" name="stories_name"
                                    placeholder={GetText()? "masukkan nama anda" : "input your name"}
                                    value={this.state.stories_name}
                                    onChange={this.handleUserInput}  
                                    ref={(input) => this.textInputStoriesName = input}
                                    disabled={this.state.input_disabled}
                                    autoFocus
                                    />
                                <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.stories_name}/>  }</div>
                            </div>
                        </div>
                        <div className="mt-3">
                            <label htmlFor="stories_email">Email</label>
                            <div className="mt-1">
                                <input type="text" className="form-control" name="stories_email"
                                    placeholder={GetText()? "masukkan email anda" : "input your email"}
                                    value={this.state.stories_email}
                                    onChange={this.handleUserInput}  
                                    ref={(input) => this.textInputStoriesEmail = input}
                                    disabled={this.state.input_disabled}
                                    />
                                <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.stories_email}/>  }</div>
                            </div>
                        </div>
                        <div className="mt-3">
                            <label htmlFor="stories_position">{GetText()? "Posisi / Jabatan" : "Position / Job TItle"}</label>
                            <div className="mt-1">
                                <input type="text" className="form-control" name="stories_position"
                                    placeholder={GetText()? "masukkan posisi / jabatan anda" : "input your position / job title"}
                                    value={this.state.stories_position}
                                    onChange={this.handleUserInput}  
                                    ref={(input) => this.textInputStoriesPosition = input}
                                    disabled={this.state.input_disabled}
                                    />
                                <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.stories_position}/>  }</div>
                            </div>
                        </div>
                        <div className="mt-3">
                            <label htmlFor="stories_company">{GetText()? "Perusahaan / Organisasi" : "Company / Organization"}</label>
                            <div className="mt-1">
                                <input type="text" className="form-control" name="stories_company"
                                    placeholder={GetText()? "masukkan perusahaan / organisasi anda" : "input your company / organization"}
                                    value={this.state.stories_company}
                                    onChange={this.handleUserInput}  
                                    ref={(input) => this.textInputStoriesCompany = input}
                                    disabled={this.state.input_disabled}
                                    />
                                <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.stories_company}/>  }</div>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <label htmlFor="stories_message">{GetText()? "Pengalaman / Cerita Anda" : "Your Experience / Story"}</label>
                            <div className="mt-1">
                                <textarea name="stories_message" className="form-control" 
                                        rows={5} 
                                        placeholder={GetText()? "masukkan pengalaman / cerita anda" : "input your experience / story"}
                                        value={this.state.stories_message} 
                                        onChange={this.handleUserInput} 
                                        ref={(input) => this.textInputStoriesMessage= input}
                                        disabled={this.state.input_disabled}
                                        maxlength="500"/>
                                <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.stories_message}/>  }</div>
                                
                            </div>
                        </div>
                    
                        <div className="mt-4 mb-3">
                            <Button variant="primary" id="submit" type="submit" style={{ width: "100%", marginTop: "20px" }}>Submit</Button>
                        </div>
                    </form>
                    </div>
                </div>
                </>
                )
              }
                   
          </div>
          <div id="loading-area" className="d-none loading"></div> 
        </div>
    );
  }
}
